import { type CategoryIcons } from '~/features/category';
import type { Level1Category } from '~/features/contact-form/category-selector-page';
import { PointDisplayMode, type PointParam } from '~/ui/point';
import { type DateFormats } from '~/utils';
import { addComma } from '~/utils';
import { rate2Percent } from '~/utils/rate2percent';

import { SvgIconCategory120 } from '../svg/category/icon-category-120';
import { SvgIconCategory140 } from '../svg/category/icon-category-140';
import { SvgIconCategory150 } from '../svg/category/icon-category-150';
import { SvgIconCategory160 } from '../svg/category/icon-category-160';
import { SvgIconCategory170 } from '../svg/category/icon-category-170';
import { SvgIconCategory180 } from '../svg/category/icon-category-180';
import { SvgIconCategory190 } from '../svg/category/icon-category-190';
import { SvgIconCategory200 } from '../svg/category/icon-category-200';
import { SvgIconCategory210 } from '../svg/category/icon-category-210';
import { SvgIconCategory220 } from '../svg/category/icon-category-220';
import { SvgIconCategory230 } from '../svg/category/icon-category-230';
import { SvgIconCategory240 } from '../svg/category/icon-category-240';
import { SvgIconCategory250 } from '../svg/category/icon-category-250';

export const categoryIcons: CategoryIcons = {
  120: SvgIconCategory120,
  140: SvgIconCategory140,
  150: SvgIconCategory150,
  160: SvgIconCategory160,
  170: SvgIconCategory170,
  180: SvgIconCategory180,
  190: SvgIconCategory190,
  200: SvgIconCategory200,
  210: SvgIconCategory210,
  220: SvgIconCategory220,
  230: SvgIconCategory230,
  240: SvgIconCategory240,
  250: SvgIconCategory250,
};

export const pointParamMax: PointParam = {
  maxLabel: '最大',
  rangeLabel: '〜',
  pointupLabel: '→',
  prefix: '株引換券',
  suffix: '',
  normal: {
    prefix: '',
    suffix: {
      rate: '%',
      amount: '枚',
    },
  },
  regular: {
    prefix: '',
    suffix: {
      rate: '%',
      amount: '枚',
    },
  },
  pointup: {
    prefix: '',
    suffix: {
      rate: '%',
      amount: '枚',
    },
  },
  numFormatter: {
    rate: (value) => rate2Percent(value, 1),
    amount: addComma,
  },
  mode: PointDisplayMode.MAX,
  achievedMark: (_: boolean) => {
    return null;
  },
  showMultiAdvertisementLabel: false,
} as const;

export const pointParamRange: PointParam = { ...pointParamMax, mode: PointDisplayMode.RANGE } as const;
export const pointParamFull: PointParam = { ...pointParamMax, mode: PointDisplayMode.FULL } as const;

export const timeToTransfer = 3000;

export const dateFormats: DateFormats = {
  yearMonth: 'YYYY/MM',
  yearMonthDay: 'YYYY/MM/DD',
  yearMonthDayTime: 'YYYY/MM/DD HH:mm',
  monthDay: 'MM/DD',
};

// Kabuand-specific contact form categories
export const kabuandContactCategories: Level1Category[] = [
  {
    value: 'category_no_reward',
    label: '株引換券が付与されない',
  },
  { value: 'category_campaign', label: '開催中や過去のキャンペーンについて' },
  { value: 'category_point_conditions', label: '株引換券の獲得条件について' },
  { value: 'category_how_to', label: 'KABU＆カブ活の使い方' },
  { value: 'category_bug', label: '不具合の報告' },
  { value: 'category_other', label: 'ご意見・その他' },
];
